import { request } from './index'
import { HTTP_METHODS } from './const'

const getStockInfoFromStore = (product_id) =>
  request({
    url: `v7/stores/inventory`,
    method: HTTP_METHODS.get,
    params: {
      product_id,
    },
  })

export default getStockInfoFromStore
